module.exports = "<div class=\"ui-g-12\">\r\n    <!-- Nombre del contenido -->\r\n    <h1>{{contenidosSeleccionados?.Titulo}}</h1>\r\n    <!--QR code del contenido-->\r\n    <qrcode [qrdata]=\"this.contenidosSeleccionados?.ENTIDAD.Id\" [level]=\"'M'\" usesvg=\"true\"></qrcode>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioQR.component.html
// module id = ../../../../../src/app/formularios/FormularioQR.component.html
// module chunks = main